import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Student',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Student',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Student',
    column_type: 'datetime',
  },
  book_club_course_numbers: {
    model_name: 'Student',
    column_type: 'string',
  },
  city: {
    model_name: 'Student',
    column_type: 'string',
  },
  course_stickiness: {
    model_name: 'Student',
    column_type: 'string',
  },
  course_times: {
    model_name: 'Student',
    column_type: 'integer',
  },
  courses_count: {
    model_name: 'Student',
    column_type: 'integer',
  },
  height: {
    model_name: 'Student',
    column_type: 'float',
  },
  name: {
    model_name: 'Student',
    column_type: 'string',
  },
  nps_list: {
    model_name: 'Student',
    column_type: 'string',
  },
  nps_source: {
    model_name: 'Student',
    column_type: 'string',
  },
  nps_value: {
    model_name: 'Student',
    column_type: 'string',
  },
  occupation: {
    model_name: 'Student',
    column_type: 'string',
  },
  phone: {
    model_name: 'Student',
    column_type: 'string',
  },
  weight: {
    model_name: 'Student',
    column_type: 'float',
  },
  youth_camp_course_numbers: {
    model_name: 'Student',
    column_type: 'string',
  },
  gender: {
    model_name: 'Student',
    column_type: 'enum',
  },
  user: {
    model_name: 'Student',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'Student',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  bridge: {
    model_name: 'Student',
    column_type: 'boolean',
  },
  holder: {
    model_name: 'Student',
    column_type: 'boolean',
  },
  partner: {
    model_name: 'Student',
    column_type: 'boolean',
  },
  potential: {
    model_name: 'Student',
    column_type: 'boolean',
  },
  student: {
    model_name: 'Student',
    column_type: 'boolean',
  },
  remark: {
    model_name: 'Student',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
